export default __webpack_public_path__ + "static/develop-b5ad1d05d8934a56ea5416e153c98b10.png";